import { FC, memo } from "react";
import { useRecoilValue } from "recoil";

import { useRideRoutes } from "@ryde/redux";
import {
  MapRouteBlockTypeEnum,
  selectedSingleRowRideDtoSelector,
} from "@ryde/shared";

import { RideGridTableMapStyled } from "./rides-grid.styled";
import { RidesMapSelectInner } from "./rides-map-select.inner";

const RidesMapSingleSelectComponent: FC = () => {
  const rideDto = useRecoilValue(selectedSingleRowRideDtoSelector);

  const { rideRoutes } = useRideRoutes(rideDto);

  return (
    <RideGridTableMapStyled>
      <div className="map_scrollable_content">
        <RidesMapSelectInner
          routes={rideRoutes}
          routeBlockType={MapRouteBlockTypeEnum.GridSingleSelect}
        />
      </div>
    </RideGridTableMapStyled>
  );
};

export const RidesMapSingleSelect = memo(RidesMapSingleSelectComponent);
